// Shared regex patterns for table processing

export const TABLE_ROW_REGEX = /^\s*\|(.+)\|\s*$/;

// Matches separator rows with dashes, colons, pipes, spaces
export const TABLE_SEPARATOR_REGEX = /^\s*\|[\s-:|]*\|\s*$/;
